/**
 * クロス商品設定画面 過去クロス商品設定一覧取得(リクエストパラメータ)用クラス
 *
 * @export PastCrossGoodsSetList
 * @class PastCrossGoodsSetList
 */
export class PastCrossGoodsSetList {
  /**  Pコード */
  public pcode = String('');
}
